import { render, staticRenderFns } from "./lossThreshold.vue?vue&type=template&id=ffd611ee&scoped=true&"
import script from "./lossThreshold.vue?vue&type=script&lang=js&"
export * from "./lossThreshold.vue?vue&type=script&lang=js&"
import style0 from "./lossThreshold.vue?vue&type=style&index=0&id=ffd611ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd611ee",
  null
  
)

export default component.exports